import { useState } from "react";

import { AlertV4, ButtonV4, FieldV4, ModalV4 } from "../common/ui";

import { CATEGORY_LABELS, codeOf, type DoneRow } from "./ordersModelV4";

// Types
type ModalCancelOrderV4Props = {
  // data
  row: DoneRow;
  busy: boolean;
  error?: unknown;
  // callback
  onClose: () => void;
  onConfirm: (data: { note: string; password: string }) => void;
};

const ModalCancelOrderV4 = (props: ModalCancelOrderV4Props) => {
  const [note, setNote] = useState("");
  const [password, setPassword] = useState("");

  const { row } = props;

  // Handler
  const handleConfirm = () => {
    props.onConfirm({ note, password });
  };

  // Render
  return (
    <ModalV4 title="ยืนยันการยกเลิก Order" width={520} tone="danger" onClose={props.onClose}>
      <div className="hv4-ord-cancel-body">
        <div className="hv4-ord-cancel-sub">
          {[codeOf(row), CATEGORY_LABELS[row.category], row.items.join(", ")].join(" · ")}
        </div>
        <FieldV4 label="เหตุผลการยกเลิก" htmlFor="hv4_ord_cancel_note">
          <input
            id="hv4_ord_cancel_note"
            className="hv4-input"
            placeholder="ไม่บังคับ เช่น สั่งผิดรายการ"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </FieldV4>
        <FieldV4 label="Password *" htmlFor="hv4_ord_cancel_password">
          <input
            id="hv4_ord_cancel_password"
            type="password"
            className="hv4-input"
            autoComplete="current-password"
            placeholder="ใส่ Password เพื่อยืนยันการยกเลิก"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </FieldV4>
        <AlertV4 tone="danger" error={props.error} />
        <div className="hv4-ord-cancel-foot">
          <ButtonV4 variant="ghost" onClick={props.onClose}>
            ไม่ยกเลิก
          </ButtonV4>
          <ButtonV4 variant="danger" disabled={props.busy} onClick={handleConfirm}>
            บันทึกการยกเลิก
          </ButtonV4>
        </div>
      </div>
    </ModalV4>
  );
};

ModalCancelOrderV4.displayName = "ModalCancelOrderV4";

export default ModalCancelOrderV4;
